import { MfeNames } from '@/utils/domains';
import { resolveGraphQLAppName } from '@/utils/graphql-path';

/**
 * GraphQL BFF hosts may differ from the MFE name (see resolveGraphQLAppName /
 * getGraphQLPath). Normalize the React Query cache key so SSR prefetches and
 * client hooks share the same dehydrated entry.
 */
export const normalizeCacheKeyAppName = (
    appName?: MfeNames,
    fallback: MfeNames = (process.env.NEXT_PUBLIC_APP_NAME as MfeNames) ?? 'app-shell',
): MfeNames => resolveGraphQLAppName(appName || fallback);
